import React from "react";
import "./style.css";

import VerticalLayout from "./VerticalLayout";
import MobileLayout from "./MobileLayout";

const Layout = () => {
  return (
    <>
      <MobileLayout />
      <VerticalLayout />
    </>
  );
};

export default Layout;
